import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import downloadIcon from '../../assets/downloadIcon.png'
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { Info } from "react-feather";

const TopResources = (props) => {

  // const [MergedPartnerResourceModal, setMergedPartnerResourceModal] = useState(false)
  const [topResourceModal, setTopResourceModal] = useState(false)

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const data = props.topResources

  const [rowData, setRowData] = useState([]);

  // for dreamBig Select options
  const [resourceNamesOptions, setResourceNamesOptions] = useState([])

  const footerRow = {
    resourcedisplay_name: "Total",
    FTU_Count: "Total : " + (
      rowData ? rowData.reduce((total, row) => total + row.FTU_Count, 0) : 0
    ),
    EU_Count: "Total : " + (
      rowData ? rowData.reduce((total, row) => total + row.EU_Count, 0) : 0
    ),
  };  

  // my use effect
  useEffect(()=>{
    setRowData(data);

    let options = data.map((obj) => {
      const {Resource_Id} = obj;

      return Resource_Id;
    })

    setResourceNamesOptions(options)
  },[data])


  // for modal open
  const openTopResourceModalisTrue = () => {
    setTopResourceModal(true)
  }

  const openTopResourceModalisFalse = () => {
    setTopResourceModal(false)
  }

  // handleMergedPartnerResourceFilterSearchClick ka copy hai for topResources
  // props.selectedOptionsTopResources
  const handleTopResourceFilterSearchClick = () => {
    if(props.selectedOptionsTopResources.length > 0){
      let selectedOptionsVals = props.selectedOptionsTopResources.map((obj) => {
        const {value} = obj
        return value;
      })

      let copyOriginalData = [...props.topResources]

      console.log(copyOriginalData, ">>>>>copyOriginalData");
      
      let filteredRowData = copyOriginalData.filter((obj) => {
        if(selectedOptionsVals.includes(obj.Resource_Id)){
          return obj
        }
      })

      console.log(filteredRowData, ">>>>filteredRowData topResources");
      setRowData(filteredRowData);
    }else if(props.selectedOptionsTopResources.length <= 0){
      setRowData(props.topResources)
    }

    setTopResourceModal(false);
  }

  // handleCLearCLick copy
  const handleClearClickTopResources = () => {
    // dreamBig
    props.setSelectedOptionsTopResources([])
  }

  //////////////////////////////////////////////////////

  const CustomCellRenderer = (props) => {
    let resourceName = props.value;
    if (resourceName === null) {
      resourceName = "Not Provided";
    }
    if (resourceName === "Total") {
      return <div style={{ textAlign: "right", display: "none" }}>{resourceName}</div>;
    } else {
      return <div>{resourceName}</div>;
    }
  };

  // in first column, we are displaying the resource title, but using Resource_Id key, because resource title is coming in Resource_Id key from backend
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "Resource_Id",
      headerName: "Resource Title",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
            <div style={{ marginRight: "110px" }}>{params.displayName}</div>
            <img
                alt=""
                src={ic_filter}
                height={"25px"}
                width={"25px"}
                className="conv-mr10"
                onClick={() => openTopResourceModalisTrue()}
            />
          </div>
        );
      },
      width: 380,
      cellStyle: { 'white-space': 'normal' },
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
    },
    {
      field: "FTU_Count",
      headerName: "First Time Count",
      // width: 180,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      field: "EU_Count",
      headerName: "Engaged Count",
      // width: 180,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ]);

  const handleTopResourceSelect = (selected) => {
    // props.setSelectedOptionsMergedPartnerResource(selected)
    // console.log("select", props.selectedOptionsMergedPartnerResource)

    //dreambig
    props.setSelectedOptionsTopResources(selected)
    console.log(">>>>select", props.selectedOptionsTopResources)
  }

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  const overlayNoRowsTemplate = rowData.length === 1 && rowData[0].sEntryPoint === "No Data Available"
  ? '<span class="ag-overlay-no-rows-center">No data available</span>'
  : '<span class="ag-overlay-no-rows-center">loading...</span>';
  

  console.log(props.selectedOptionsTopResources, ">>>>>>props.selectedOptionsTopResources");
  
  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        margin: 10
      }}>
        <h3 className="spled-colored-label" style={{
          fontSize: "20px",
          textAlign: 'center',
          marginRight: 10
        }}>4. First time and Engaged Users based on Top Resource Availed</h3>
        <span style={{ cursor: "pointer" }} title="Display of First time users and engaged users based on Partner / Resource Availed by partner entry points">
          <Info style={{ width: "15px", marginRight: "10px", marginBottom:"5px" }} />
        </span>
      </div>
      <div style={{
        height: "50vh",
      }}>
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <div style={gridStyle} className="ag-theme-material">
            <AgGridReact ref={gridRef}
              rowData={rowData}
              // rowData={props.topResources}
              columnDefs={columnDefs}
              pinnedBottomRowData={[footerRow]}
              gridOptions={gridOptions}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No data available...</span>'
              }
              rowClassRules={{
                'total-row': 'data.resourcedisplay_name === "Total"'
              }}
            >
            </AgGridReact>
          </div>
        </div>

        <Modal isOpen={topResourceModal}>
          <ModalContent className="EngagedDashboard-filter-modal">
            <div className="modal-header">
              <span className="modal-title">Filter</span>
              <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={openTopResourceModalisFalse}
              />
            </div>

            <div className="modal-body">
              <br />
              <div className="row">
                <div className="col-12 spled-container">
                  <div className="width-100">
                    <ReactMultiSelectCheckboxes
                      options={resourceNamesOptions.map((resourceId) => ({
                        label: resourceId,
                        value: resourceId,
                      }))}
                      placeholderButtonLabel="Select Resource-Id"
                      value={props.selectedOptionsTopResources}
                      onChange={handleTopResourceSelect}
                    />
                  </div>
                </div>
              </div>
              <br />
              <div className='row d-flex justify-content-center align-items-center'>
                <div className="offset-1 col-5">
                  <Button className="esp-inline-button" 
                    onClick={handleTopResourceFilterSearchClick}
                  >Search</Button>
                </div>
                <div className="col-5">
                  <Button className="esp-inline-button" 
                    onClick={handleClearClickTopResources}
                    >Clear</Button>
                </div>
              </div>

            </div>
          </ModalContent>
        </Modal>
      </div>
    </div>
  )
}

export default TopResources
